/*
 * @Description: enter your description
 * @Autor: zczhang
 * @Date: 2020-07-27 16:04:16
 * @LastEditors: zczhang
 * @LastEditTime: 2020-07-27 16:26:58
 */
import Vuex from 'vuex'
import Vue from 'vue'
import common from './common'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        common
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js